import { FullUser } from "authentication/domain/FullUser";

export function readGroup(moduleName: string): string {
    return moduleName.concat('-', 'read');
}

export function writeGroup(moduleName: string): string {
    return moduleName.concat('-', 'write');
}

export function fullAccessGroup(moduleName: string): string {
    return moduleName.concat('-', 'full');
}

export function hasReadAccessTo(user: FullUser | undefined, moduleName: string): boolean {
    if (user === undefined) {
        return false;
    }
    return user.isInAnyGroup([readGroup(moduleName), writeGroup(moduleName), fullAccessGroup(moduleName), "admin"]);
}

export function hasWriteAccessTo(user: FullUser | undefined, moduleName: string): boolean {
    if (user === undefined) {
        return false;
    }
    return user.isInAnyGroup([writeGroup(moduleName), fullAccessGroup(moduleName), "admin"]);
}

export function hasFullAccessTo(user: FullUser | undefined, moduleName: string): boolean {
    if (user === undefined) {
        return false;
    }
    return user.isInAnyGroup([fullAccessGroup(moduleName), "admin"]);
}
